import { render } from "./Offcanvas.vue?vue&type=template&id=38818113"
import script from "./Offcanvas.vue?vue&type=script&lang=js"
export * from "./Offcanvas.vue?vue&type=script&lang=js"

import "./Offcanvas.vue?vue&type=style&index=0&id=38818113&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__